import { COLORS } from '@/styles/colors';
import { flex } from '@/styles/layout';
import { bodySmall, poppinsRegularFont } from '@/styles/typography';
import styled from 'styled-components';

export const CustomValidationRow = styled.div`
  ${flex({ alignItems: 'center' })};
  width: 100%;
`;

export const MessageBlock = styled.div`
  color: ${COLORS.black};
  ${poppinsRegularFont};
  ${bodySmall};
  margin: 0 0 0 8px;
`;
